var LanguageSelector, PNHeaderV2, User, gcxFlyout, getCardatronCards, grouponFingerprint, gtgModal, inAppMessage, incognitoTest, setCLLTimer, stickyHeader, uncommentThirdPartyAssets;

if (!$(document.head).find('#sls, #sls-packaged').length || !(window._phantom || window.callPhantom)) {
  $(document.head).find('script').remove();
}

require('../../src/frontend/core/dom_js_shim');

require('./common/underscore_mixins');

window.Hogan = require('hogan.js');

require('./groupon_modules/groupon');

require('../../modules/gig_body/components/cookie_banner/frontend/main');

require('../../modules/gig_body/header/search_bar/frontend/index');

require('../../src/frontend/helper/lazyLoadImages');

require('./groupon_modules/performance');

LanguageSelector = require('../../modules/gig_body/header/language_menu/frontend/language_selector');

PNHeaderV2 = require('../../modules/gig_body/header/frontend/views/pn_header_v2');

stickyHeader = require('../../modules/gig_body/header/frontend/sticky_header');

inAppMessage = require('../../modules/in_app_messages/frontend/main');

require('../../modules/gig_body/components/back2top/frontend/main');

require('../../modules/google_maps/frontend/main');

require('../../modules/doubleclick/frontend/doubleclick');

require('./groupon_modules/verifyUserCookies');

require('./groupon_modules/loadSiteBlindado');

require('../../modules/qualtrics/frontend/qualtrics');

require('../../modules/gig_body/header/responsive_menu/frontend/view/responsive_menu');

gtgModal = require('../../modules/shared/modals/frontend/gtg-modal');

User = require('../../modules/gig_body/header/usernav/frontend/setup_user').User;

uncommentThirdPartyAssets = require('./groupon_modules/uncommentThirdPartyAssets');

gcxFlyout = require('../../modules/gig_body/header/sub_nav/frontend/init_flyout');

incognitoTest = require('../../src/frontend/helper/incognito').incognitoTest;

setCLLTimer = require('../../src/frontend/helper/search/helper/m_detectCurrentLocation').setCLLTimer;

grouponFingerprint = require('grpn_fingerprint');

getCardatronCards = require('../../modules/service_calls/frontend/getCardatronCards').getCardatronCards;

incognitoTest('desktop');

$(document).ready(function() {
  var $header, i, mMax, ref, ref1;
  gtgModal.init();
  mMax = Groupon.LS.mediaQueries.mMax;
  if (Groupon.LS.hasTouch && (typeof matchMedia === "function" ? matchMedia(mMax).matches : void 0)) {
    $(document.head).find('meta[name=viewport]').attr('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0');
  }
  if ($('html').hasClass('lt-ie10')) {
    $(document.body).removeClass('ls-resp responsive-funnel');
  }
  Groupon.Utils.lazyLoadImages();
  if (($header = $('.header-v2')).length) {
    Groupon.Modules.Header = new PNHeaderV2($header);
  }
  if (Groupon.PageFlags.isLegacyResponsive) {
    new Groupon.LS.Header.PNResponsiveMenu;
  }
  User.init();
  if ($('#ls-lang-selected').length) {
    new LanguageSelector();
  }
  if (document.getElementById('ls-cookie-banner')) {
    new CookieBanner('#ls-cookie-banner');
  }
  $('body').removeClass('no-js');
  if (!Optimize.delayBloodhound) {
    OptimizeSuite.initBloodhound();
  }
  $('a.t-back-link').not('[href]').on('click', function() {
    return history.back();
  });
  $('.getaways-tab-flyout [data-bhc$="ga-search"]').click(function() {
    Cookie.unset('flyOut_shown', '.groupon.com');
    return Cookie.unset('flyOut_shown');
  });
  if ((ref = Cookie.get('has_cpp')) === '1' || ref === 'true') {
    $('#user-my-page').removeClass('hidden');
  }
  if ($('#ZN_6YfZFn20DN7x5hH').length) {
    try {
      new Groupon.qualtrics(100, 'r', 'QSI_S_ZN_6YfZFn20DN7x5hH', '//zn6yfzfn20dn7x5hh-groupon.siteintercept.qualtrics.com/WRSiteInterceptEngine/?Q_ZID=ZN_6YfZFn20DN7x5hH&Q_LOC=' + encodeURIComponent(window.location.href)).start();
    } catch (error) {
      i = error;
    }
  }
  if ((ref1 = $("#subscribe_modal_container")) != null) {
    ref1.trigger('launchSubsUIModal');
  }
  return gcxFlyout.init();
});

$(window).on('load', function() {
  var ref, ref1, ref2, ref3, ref4, ref5;
  if (Optimize.delayBloodhound) {
    setTimeout((function() {
      return OptimizeSuite.initBloodhound();
    }), 100);
  }
  if (Cookie.get('cll') != null) {
    setCLLTimer();
  }
  Groupon.Utils.lazyLoadImages({
    threshold: 200
  }, '.lazy-wl');
  new Groupon.Widgets.BackToTopButton;
  inAppMessage.init();
  if ($('.header-v2').length) {
    stickyHeader.init('search');
  }
  Groupon.verifyUserCookies();
  if ($('.footer-siteblindado-br').length) {
    Groupon.loadSiteBlindado();
  }
  uncommentThirdPartyAssets();
  if (typeof Groupon !== "undefined" && Groupon !== null ? (ref = Groupon.LS) != null ? (ref1 = ref.flags) != null ? ref1.useCardatronNavCards : void 0 : void 0 : void 0) {
    getCardatronCards();
  }
  if (typeof Groupon !== "undefined" && Groupon !== null ? (ref2 = Groupon.LS) != null ? (ref3 = ref2.flags) != null ? ref3.enableFingerprint : void 0 : void 0 : void 0) {
    setTimeout((function() {
      return new grouponFingerprint;
    }), 100);
  }
  if ((typeof Groupon !== "undefined" && Groupon !== null ? (ref4 = Groupon.LS) != null ? (ref5 = ref4.data) != null ? ref5.appName : void 0 : void 0 : void 0) === 'deal') {
    if (typeof Finch !== "undefined" && Finch !== null) {
      Finch.experiment("LS-3080-AADealPageBucketing", {
        Control: function() {},
        Treatment: function() {}
      });
    }
  }
});

